"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Needs to be in sync with the definitions in _viewports.scss

var Viewports;

(function (Viewports) {
  Viewports[Viewports["XL"] = 1680] = "XL";
  Viewports[Viewports["LG"] = 1196] = "LG";
  Viewports[Viewports["MD"] = 1024] = "MD";
  Viewports[Viewports["SM"] = 640] = "SM";
  Viewports[Viewports["XS"] = 0] = "XS";
})(Viewports = exports.Viewports || (exports.Viewports = {}));